/* global carrotquest */
define(['jquery'], $ => {
    return {
        init() {
            this.initCache();
            // this.initEvents();
            this.showIcons();
        },

        initCache() {
            this.isExpandeState = false;
            this.expandedHtmlClass = '_expanded';

            this.container = '.js-chat-icons';
            this.closeBtn = '.js-chat-icons-close';
            this.mainBtn = '.js-chat-icons-main';

            this.$container = $(this.container);
            this.$closeBtn = this.$container.find(this.closeBtn);
            this.$mainBtn = this.$container.find(this.mainBtn);
        },

        initEvents() {
            this.$closeBtn.on('click', this.collapse.bind(this));
            this.$mainBtn.on('click', this.expand.bind(this));
        },

        collapse() {
            this.isExpandeState = false;
            this.updateContainerHtmlState();
        },

        expand() {
            this.isExpandeState = true;
            this.updateContainerHtmlState();
        },

        updateContainerHtmlState() {
            this.$container.toggleClass(
                this.expandedHtmlClass,
                this.isExpandeState
            );
        },

        showIcons() {
            this.$container.fadeIn();
        },
    };
});
